// src/cfg/publicRoutes.ts
import { matchPath } from 'react-router-dom';

export const PUBLIC_PATHS = [
  '/', // SiteRedirect
  '/auth/login',
  '/auth/register',
  '/auth/reset-pass',
  '/auth/forgot-password',
  '/auth/logout',
  '/no-access',

  '/web',
  '/web/*',

  // eShop público
  '/eshop',
  '/eshop/catalogue/*',
  '/eshop/category/*',
  '/eshop/detail/:slug_id',
  '/eshop/cart',
  '/eshop/checkout',

  '/eshop/checkout/preview/:previewHash',
  '/track/:accessToken',
  '/pay/return/*',
  '/q/:publicId',
  '/quotes/public/:publicId',
];

const PRIVATE_ESHOP_PREFIXES = ['/eshop/dashboard', '/eshop/account'] as const;

const hasPathPrefix = (pathname: string, prefix: string): boolean => (
  pathname === prefix || pathname.startsWith(`${prefix}/`)
);


/**
 * Normaliza la ruta y verifica si es pública
 * - Ignora query params y hash
 * - "/" no permite subpáginas
 * - Con "/*" sí permite subrutas
 */
export const isPublicPath = (inputPath: string): boolean => {
  // Ignorar querystring y hash
  const clean = inputPath.split('?')[0].split('#')[0];
  const path = clean !== '/' ? clean.replace(/\/+$/, '') : '/';

  // A missing public eShop URL must reach the SPA 404 fallback without being
  // treated as a private route. Administrative eShop surfaces remain guarded.
  if (
    path.startsWith('/eshop/')
    && !PRIVATE_ESHOP_PREFIXES.some((prefix) => hasPathPrefix(path, prefix))
  ) {
    return true;
  }

  for (const raw of PUBLIC_PATHS) {
    // defensivo: ignorar ? o # en el patrón si los hubiera
    const [pattern] = raw.split(/[?#]/);
    const wildcard = pattern.endsWith('/*');

    if (wildcard) {
      // base del patrón sin '/*'
      const base = pattern.slice(0, -2) || '/';
      const baseNorm = base !== '/' ? base.replace(/\/+$/, '') : '/';

      // Permite la base exacta y cualquier subruta
      if (path === baseNorm || !!matchPath({ path: pattern, end: false }, path)) {
        return true;
      }
    } else {
      // Sin comodín: debe coincidir EXACTO (pero soporta :params)
      if (matchPath({ path: pattern, end: true }, path)) {
        return true;
      }
    }
  }

  return false;
};
